import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import StyledAvatar from 'components/StyledAvatar';

const AuthorSection = styled(Grid)`
  margin: 20px 0;
`;

const AuthorAvatar = styled(StyledAvatar)`
  margin-bottom: 20px;
`;

class Author extends React.PureComponent {
  renderAvatar() {
    const { author } = this.props;

    if (author.bio_image) {
      return (
        <AuthorAvatar
          src={`${author.bio_image.url}?format=pjpg&width=150&auto=webp`}
        />
      );
    }

    return <AuthorAvatar>{author.name[0]}</AuthorAvatar>;
  }

  render() {
    const { author } = this.props;

    return (
      <AuthorSection
        container
        alignItems="flex-start"
        justify="center"
        itemProp="author"
      >
        <Grid item xs={12} md={10}>
          <Typography variant="h5" gutterBottom>
            {author.name}
          </Typography>
          <Typography variant="body1">{author.about}</Typography>
        </Grid>
        <Grid item xs={12} md={2} align="center">
          {this.renderAvatar()}
        </Grid>
      </AuthorSection>
    );
  }
}

Author.propTypes = {
  author: PropTypes.shape({
    about: PropTypes.string.isRequired,
    bio_image: PropTypes.shape({
      url: PropTypes.string.isRequired
    }),
    name: PropTypes.string.isRequired
  }).isRequired
};

export default Author;
